import React, { useState } from 'react';
import { Layout } from 'antd';
import AppHeader from './AppHeader';
import MultiTenantSider from './MultiTenantSider';
import AppFooter from './AppFooter';
import CommuneAccessGuard from '../CommuneAccessGuard';

const { Content } = Layout;

interface AppLayoutProps {
  children: React.ReactNode;
}

const AppLayout: React.FC<AppLayoutProps> = ({ children }) => {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <MultiTenantSider collapsed={collapsed} onCollapse={setCollapsed} />
      <Layout 
        style={{ 
          marginLeft: collapsed ? 80 : 280,
          transition: 'margin-left 0.2s ease',
          background: 'linear-gradient(135deg, #f0fdf4 0%, #ecfdf5 50%, #f0fdf4 100%)',
          minHeight: '100vh'
        }}
      >
        <AppHeader collapsed={collapsed} onMenuToggle={() => setCollapsed(!collapsed)} />
        <Content
          style={{
            margin: '24px 24px 0',
            padding: '32px',
            background: 'rgba(255, 255, 255, 0.95)',
            backdropFilter: 'blur(20px)',
            borderRadius: '20px 20px 0 0',
            border: '1px solid #d1fae5',
            borderBottom: 'none',
            boxShadow: '0 -4px 12px rgba(34, 197, 94, 0.08)',
            position: 'relative',
            overflow: 'hidden',
            minHeight: 'calc(100vh - 140px)',
          }}
        >
          {/* Enhanced decorative elements with Jiigy-style */}
          <div
            style={{
              position: 'absolute',
              top: '-40px',
              right: '-40px',
              width: '160px',
              height: '160px',
              background: 'linear-gradient(135deg, rgba(74, 222, 128, 0.1), rgba(34, 197, 94, 0.1))',
              borderRadius: '50%',
              zIndex: 0,
              opacity: 0.8,
              filter: 'blur(20px)',
            }}
          />
          <div
            style={{
              position: 'absolute',
              top: '20%',
              right: '10%',
              width: '80px',
              height: '80px',
              background: 'linear-gradient(135deg, rgba(22, 163, 74, 0.05), rgba(16, 185, 129, 0.05))',
              borderRadius: '50%',
              zIndex: 0,
              opacity: 0.9,
            }}
          />
          <div
            style={{
              position: 'absolute',
              bottom: '-80px',
              left: '-80px',
              width: '220px',
              height: '220px',
              background: 'linear-gradient(135deg, rgba(34, 197, 94, 0.06), rgba(74, 222, 128, 0.06))',
              borderRadius: '50%',
              zIndex: 0,
              opacity: 0.7,
              filter: 'blur(30px)',
            }}
          />
          
          {/* Subtle pattern overlay */}
          <div
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              background: 'url("data:image/svg+xml,%3Csvg width="100" height="100" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg"%3E%3Cg fill-opacity="0.02"%3E%3Cpolygon fill="%2322c55e" points="50 0 60 40 100 50 60 60 50 100 40 60 0 50 40 40"/%3E%3C/g%3E%3C/svg%3E")',
              zIndex: 0,
              opacity: 0.3,
            }}
          />
          
          <div style={{ position: 'relative', zIndex: 1 }}>
            <CommuneAccessGuard>
              {children}
            </CommuneAccessGuard>
          </div>
        </Content>
        <AppFooter />
      </Layout>
    </Layout>
  );
};

export default AppLayout;